import styled from 'styled-components';
import { INVOICES_TABLE_COLUMNS } from '../../Invoices.constants';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Row = styled.div`
  display: grid;
  grid-template-columns: ${INVOICES_TABLE_COLUMNS};
  gap: 16px;
  align-items: center;
  height: 68px;
  padding: 0 20px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.primary.border};
  cursor: pointer;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: ${({ theme }) => theme.palette.system.lightBackground};
  }
`;

export const Cell = styled(Typography.Body).attrs({ as: 'div' })`
  color: ${({ theme }) => theme.palette.primary.labels};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Amount = styled(Typography.Body).attrs({ as: 'div' })`
  color: ${({ theme }) => theme.palette.primary.labels};
  font-weight: 500;
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StatusCell = styled.div`
  display: flex;
  justify-content: flex-end;
  min-width: 0;
`;

export const DownloadCell = styled.div`
  display: flex;
  justify-content: center;
`;

export const Download = styled.a`
  display: flex;
  color: ${({ theme }) => theme.palette.secondary.labels};

  svg path {
    stroke: currentColor;
  }
`;

export const ChevronCell = styled.div`
  display: flex;
  justify-content: flex-end;
  color: ${({ theme }) => theme.palette.primary.labels};
`;
